import { Map, Set } from "immutable";
import Widget, { widgetAttributesForComparison } from "views/logic/widgets/Widget";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import { MESSAGE_FIELD } from "views/Constants";
import LogViewWidgetConfig from "./LogViewWidgetConfig";
const _LogViewWidget = class _LogViewWidget extends Widget {
  constructor(id, config, filter, timerange, query, streams = [], stream_categories = [], filters = [], description, context) {
    super(
      id,
      _LogViewWidget.type,
      config,
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
  // eslint-disable-next-line class-methods-use-this
  get isExportable() {
    return true;
  }
  static fromJSON(value) {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = value;
    return new _LogViewWidget(
      id,
      LogViewWidgetConfig.fromJSON(config),
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
  static fromMessageTable(messageTable) {
    const { showMessageRow, fields } = messageTable.config;
    const needsMessageField = showMessageRow && !fields.includes(MESSAGE_FIELD);
    const logViewFields = Set(needsMessageField ? [...fields, MESSAGE_FIELD] : fields);
    return _LogViewWidget.builder().id(messageTable.id).query(messageTable.query).timerange(messageTable.timerange).streams(messageTable.streams).streamCategories(messageTable.streamCategories).filter(messageTable.filter).filters(messageTable.filters).config(LogViewWidgetConfig.createDefault().toBuilder().fields(logViewFields).build()).build();
  }
  equals(other) {
    if (other instanceof _LogViewWidget) {
      return widgetAttributesForComparison.every((key) => isDeepEqual(this[key], other[key]));
    }
    return false;
  }
  equalsForSearch(other) {
    if (other instanceof _LogViewWidget) {
      return widgetAttributesForComparison.every((key) => isEqualForSearch(this[key], other[key]));
    }
    return false;
  }
  toBuilder() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this._value;
    return new Builder(
      Map({ id, config, filter, timerange, query, streams, stream_categories, filters, description, context })
    );
  }
  static builder() {
    return new Builder();
  }
  static isLogViewWidget(widget) {
    return widget && widget.type === _LogViewWidget.type;
  }
};
_LogViewWidget.type = "logs";
_LogViewWidget.defaultTitle = "Untitled Log View";
let LogViewWidget = _LogViewWidget;
export {
  LogViewWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this.value.toObject();
    return new LogViewWidget(
      id,
      config,
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
}
